<template>
  <div class="content">
    <Modal
      v-model="showModal"
      :title="titleTxt"
      @on-ok="confirm"
      @on-cancel="cancel"
      :loading="$root.$children[0].modalLoading"
      width="1000"
      class="my-modal top"
    >
      <div class="form-wrap" v-if="showModal">
        <Form :model="formData" :rules="formRules" ref="formRef" :label-width="130">
          <FormItem label="考试名称" class="less" prop="name">
            <Input
              v-model="formData.name"
              placeholder="请输入"
              @on-blur="
                event => {
                  formData.name = event.target.value.trim();
                }
              "
              :maxlength="32"
              :show-word-limit="true"
              clearable
            />
          </FormItem>
          <FormItem label="考试分类" class="less" prop="columnList">
            <Select v-model="formData.columnList" multiple style="width: 250px">
              <Option v-for="item in list" :value="item.id" :key="item.id">{{ item.name }} </Option>
            </Select>
            <span class="table-btn" @click="openTemplateEdit({})" style="margin-left: 15px; margin-right: 0">新增分类</span>
          </FormItem>
          <FormItem label="考试时长(分钟)" class="less" prop="length" :rules="[{ validator: validateAge, trigger: 'blur', type: 'number' }]">
            <Input
              v-model="formData.length"
              placeholder="请输入"
              type="number"
              @on-blur="
                event => {
                  formData.length = event.target.value.trim();
                }
              "
              clearable
            />
          </FormItem>
          <FormItem v-if="formData.id" label="考题数量" class="less" prop="nums">
            <Input v-model="formData.nums" placeholder="请输入" disabled clearable />
          </FormItem>
          <FormItem label="最多考试次数" class="less" prop="maxTimes" :rules="[{ validator: validateAge, trigger: 'blur', type: 'number' }]">
            <Input
              v-model="formData.maxTimes"
              placeholder="请输入"
              type="number"
              @on-blur="
                event => {
                  formData.maxTimes = event.target.value.trim();
                }
              "
              clearable
            />
          </FormItem>
          <FormItem label="有效期" class="less" prop="isLong">
            <DatePicker v-model="dateVal" :transfer="true" type="daterange" placement="bottom-end" @on-change="changeDate" placeholder="不选有效期默认长期有效">
            </DatePicker>
          </FormItem>
          <FormItem label="展示机构" class="less" prop="orgIdList">
            <selectTree
              v-model="formData.orgIdList"
              :multiple="true"
              ref="selectTreeRef"
              :checkChild="true"
              @getTreeData="getOrgTreeData"
              type="4"
              status="1"
            ></selectTree>
          </FormItem>
          <FormItem label="排序" class="less" prop="orderNum" :rules="[$units.formRule.justIntSort()]">
            <Input
              v-model="formData.orderNum"
              placeholder="请输入正整数，排序越大越靠前"
              number
              @on-blur="
                event => {
                  formData.orderNum = event.target.value.trim();
                }
              "
              clearable
            />
          </FormItem>
        </Form>
      </div>
    </Modal>

    <editCourse ref="editCourse" @reload="getMenuList"></editCourse>
  </div>
</template>
<script>
import selectTree from '@/components/system/selectTree3';
import editCourse from '../../testMenu/components/editCourse';
export default {
  components: {
    selectTree,
    editCourse
  },
  props: ['menuList'],
  watch: {
    menuList: {
      handler(newVal) {
        this.list = newVal;
      },
      deep: true,
      immediate: true
    },
    showModal: {
      handler(newVal) {
        if (!newVal) {
          this.$refs.formRef && this.$refs.formRef.resetFields();
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      list: [],
      dateVal: [],
      showModal: false,
      canEdit: true, //是否可编辑
      formData: {
        id: '',
        name: '', //名称
        orgIdList: [], //机构
        columnList: [], //分类 ,Long
        isLong: '', //有效期是否长期有效  1-是 0-否
        beginDate: '', //有效期开始日期
        endDate: '', //有效期截止日期
        isUse: '0', //上架状态
        nums: '', //试题数
        maxTimes: '', //可考试次数
        length: '', //考试时长（分）
        orderNum: '' //排序
      }, // 协议文件列表
      formRules: {
        name: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        columnList: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
            type: 'array'
          }
        ],
        orgIdList: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
            type: 'array'
          }
        ]
      },
      titleTxt: '', // 标题
      showOrgIdsArr: []
    };
  },
  created() {},
  methods: {
    getMenuList() {
      this.$emit('refresh');
    },
    // 打开模板编辑或新增弹窗
    openTemplateEdit() {
      this.$refs.editCourse.open({});
    },
    // 默认勾选展示机构
    getOrgTreeData(data) {
      if (!this.formData.id) {
        this.$nextTick(() => {
          this.dealTree(data);
          this.$refs.selectTreeRef.setSelectIdByChecked();
        });
      }
    },

    // 得到树结构id，组成新数组
    dealTree(arr) {
      arr.forEach(item => {
        this.$set(item, 'checked', true);
        if (item.children) {
          this.dealTree(item.children);
        }
      });
    },
    validateAge(rule, value, callback) {
      let reg = new RegExp('^[0-9]*[1-9][0-9]*$');
      if (!value) {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    changeDate(res) {
      this.dateVal = res;
      this.formData.isLong = res[0] ? 0 : 1;
      this.formData.beginDate = res[0];
      this.formData.endDate = res[1];
    },
    async open(item) {
      this.showOrgIdsArr = [];
      for (let key in this.formData) {
        if (key == 'orgIdList' || key == 'columnList') {
          this.formData[key] = [];
        } else {
          this.formData[key] = '';
        }
      }
      if (item.id) {
        this.formData.id = item.id;
        await this.getDetail();
      } else {
        this.formData.id = '';
        this.formData.isUse = '0';
        this.dateVal = [];
      }
      this.getMenuList();
      this.titleTxt = item.id ? '编辑' : '新增';
      this.showModal = true;
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(!item.id);
      });
    },
    // 详情
    getDetail() {
      return this.$http({
        url: `/buz/testCenter/read/detail`,
        type: 'GET',
        data: {
          id: this.formData.id
        }
      }).then(res => {
        if (res.data.beginDate && res.data.endDate) {
          this.dateVal = [new Date(res.data.beginDate), new Date(res.data.endDate)];
        } else {
          this.dateVal = [];
        }
        this.formData = res.data;
      });
    },
    confirm() {
      this.$units.notCloseModal(this);
      this.$refs['formRef']
        .validate(valid => {
          if (valid) {
            this.$http({
              url: this.formData.id ? '/buz/testCenter/edit' : `/buz/testCenter/add`,
              type: 'POST',
              data: this.formData,
              apiPermissionCode: ''
            }).then(res => {
              this.$Message.success(this.formData.id ? '修改成功' : '新增成功');
              this.showModal = false;
              this.$emit('reload');
            });
          } else {
          }
        })
        .catch(e => {});
    },
    cancel() {}
  }
};
</script>
<style lang="scss" scoped>
.form-wrap {
  margin-top: 10px;

  .ivu-form {
    display: flex;
    flex-wrap: wrap;
  }

  /deep/.ivu-form-item-error-tip {
    top: unset;
  }

  /deep/ .ivu-form-item-label {
    word-break: keep-all;
    line-height: 32px;
    padding: 0 12px 0 0;
  }

  /deep/ .ivu-form-item {
    width: 33.333333%;
    padding-right: 30px;
    vertical-align: top;
    margin: 0;
    display: flex;
    margin-bottom: 25px;

    &.less {
      width: 50%;
    }

    &.two {
      width: 66.666666%;
    }

    &.full {
      width: 100%;
    }

    &.three {
      width: 33%;
    }

    &.four {
      width: 25%;
    }

    &.big-label {
      .ivu-form-item-label {
        white-space: nowrap;
        float: none;
      }

      .ivu-form-item-content {
        display: inline-block;
        margin-left: 0 !important;
      }
    }
  }

  /deep/ .ivu-form-item-content {
    width: 100%;
    line-height: 32px;
    margin-left: 0 !important;

    > div {
      width: 100%;
    }

    .ivu-input {
      width: 100%;
    }
  }

  .btn-upload {
    display: inline-block;
    width: 88px;
    height: 32px;
    background: #f5f8ff;
    border-radius: 2px;
    border: 1px solid #eaf2ff;
    cursor: pointer;
    font-size: 14px;
    color: #236dff;
    line-height: 32px;
    text-align: center;
  }

  /deep/.uploadBoxs {
    width: 145px;
    height: 94px;
  }

  /deep/.demo-upload-list {
    width: 145px;
    height: 94px;
  }

  /deep/.demo-upload-list {
    img {
      width: 145px;
      height: 94px;
    }
  }

  textarea {
    width: 100%;
    height: 120px;
    border: 1px solid #dcdee2;
    outline: none;
    padding: 10px;
    resize: none;
    border-radius: 4px;
  }
}

.form-wrap {
  &::v-deep {
    .ivu-form-item {
      .ivu-form-item-content {
        width: calc(100% - 100px) !important;
      }
    }
  }
}
</style>
